/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LightbulbIcon20Solid = forwardRef('LightbulbIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M14.38 11.658c-.603.643-1.078 1.44-1.078 2.321a.01.01 0 0 1-.01.01H10.75V7.823a.75.75 0 0 0-1.5 0v6.166H6.707a.01.01 0 0 1-.01-.01c0-.885-.475-1.685-1.08-2.332a6 6 0 1 1 8.763.011Z" }),
        React.createElement("path", { d: "M12.83 16.554H7.18a.75.75 0 0 1 0-1.5h5.65a.75.75 0 1 1 0 1.5Z" }),
        React.createElement("path", { d: "M8.566 17.5a.75.75 0 0 0 0 1.5h2.868a.75.75 0 0 0 0-1.5H8.566Z" })));
});
